import React from "react";
import ConstantHelper from "../../Helpers/ConstantHelper";

// Plain outbound link to the Calendly intro-call page (opens in a new tab).
// No embed script, so it needs no extra Content-Security-Policy allowance.
const BookCallButton = ({ className = "primary-btn text-uppercase px-4" }) => (
  <a
    href={ConstantHelper.bookIntroCallUrl}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
  >
    {ConstantHelper.bookIntroCallLabel}
  </a>
);

export default BookCallButton;
